import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import pictureModal from 'store/app/ui/modals/picture/action';
import videoModal from 'store/app/ui/modals/video/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    pictureModal: bindActionCreators(pictureModal, dispatch),
    videoModal: bindActionCreators(videoModal, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
